import { useEffect, useState } from "react";
import { decryptData, defaulUrl } from "../../components/const";
import Swal from "sweetalert2";
const CommandeAttente = () => {
    const [commandes, setCommandes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [erreur, setErreur] = useState(null);

    const [searchClient, setSearchClient] = useState("");
    const [dateDebut, setDateDebut] = useState("");
    const [dateFin, setDateFin] = useState("");

    const [editingCmdId, setEditingCmdId] = useState(null);
    const [editingDetails, setEditingDetails] = useState({});
    const [remise, setRemise] = useState(0);
    const [paye, setPaye] = useState(0);

    const [remiseInput, setRemiseInput] = useState("0");
    const [payeInput, setPayeInput] = useState("0");

    const idmagasin = decryptData("user_profile").idmagasin;
    useEffect(() => {
        const fetchCommandes = async () => {
            setLoading(true)
            try {
                const response = await fetch(`${defaulUrl}cmd-attente/${idmagasin}`);
                if (!response.ok) throw new Error("Erreur lors du chargement");
                const data = await response.json();
                setCommandes(data);
            } catch (error) {
                setErreur(error.message);
            } finally {
                setLoading(false);
            }
        };
        fetchCommandes();
    }, [idmagasin]);

    const toggleEdition = (cmd) => {
        if (editingCmdId === cmd.id) {
            setEditingCmdId(null);
            setEditingDetails({});
            setRemise(0);
            setPaye(0);
            setRemiseInput("0");
            setPayeInput("0");
        } else {
            setEditingCmdId(cmd.id);
            const initDetails = {};
            cmd.details.forEach((d) => {
                initDetails[d.id] = {
                    pvu: d.pvu,
                    quantite_cmd: d.quantite_cmd,
                    quantite_livre: d.quantite_cmd,
                    idstock: d.idstock
                };
            });
            setEditingDetails(initDetails);
            setRemise(0);

            setRemiseInput("0");
            // setPayeInput(cmd.montant_total.toString());
        }
    };

    const handleChange = (detailId, field, value) => {
        setEditingDetails((prev) => ({
            ...prev,
            [detailId]: {
                ...prev[detailId],
                [field]: ["pvu", "quantite_cmd", "quantite_livre"].includes(field)
                    ? Number(value)
                    : value,
            },
        }));
    };

    const calculerTotalNet = () => {
        let total = 0;
        for (const key in editingDetails) {
            const d = editingDetails[key];
            total += d.pvu * d.quantite_livre;
        }
        total -= remise;
        return total > 0 ? total : 0;
    };

    const validerCommande = async (cmdId) => {
        const detailsToSend = Object.entries(editingDetails).map(([detailId, vals]) => ({
            id: detailId,
            pvu: vals.pvu,
            quantite_cmd: vals.quantite_cmd,
            quantite_livre: vals.quantite_livre,
            idstock: vals.idstock
        }));

        const payload = {
            remise,
            paye,
            details: detailsToSend,

        };
        try {
            setLoading(true)
            const response = await fetch(`${defaulUrl}valider-cmd/${cmdId}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${decryptData("ACCESS_TOKEN")}`,
                },
                body: JSON.stringify(payload),
            });
            const data = await response.json()

            if (!response.ok) {
                throw new Error("Erreur lors de la validation et livraison" + data.message)
            };
            Swal.fire({
                title: "Success",
                text: "Validation effectuee",
                icon: "success"
            })
            setEditingCmdId(null);
            setEditingDetails({});
            setRemise(0);
            setPaye(0);
            setCommandes((prev) => prev.filter((c) => c.id !== cmdId));
        } catch (e) {
            Swal.fire({
                title: "Erreur",
                text: e.message,
                icon: "error"
            })

        } finally {
            setLoading(false)
        }
    };

    const commandesFiltrees = commandes.filter((cmd) => {
        const clientStr = cmd.client.client.toLowerCase() + " " + cmd.client.telephone.toLowerCase();
        if (!clientStr.includes(searchClient.toLowerCase())) return false;

        if (dateDebut) {
            const cmdDate = new Date(cmd.created_at);
            const deb = new Date(dateDebut);
            if (cmdDate.setHours(0, 0, 0, 0) < deb.setHours(0, 0, 0, 0)) return false;
        }
        if (dateFin) {
            const cmdDate = new Date(cmd.created_at);
            const fin = new Date(dateFin);
            if (cmdDate.setHours(0, 0, 0, 0) > fin.setHours(0, 0, 0, 0)) return false;
        }
        return true;
    });


    if (erreur) return <div className="text-danger text-center">{erreur}</div>;
    return (
        <div className="container mt-3">
            {loading && <div className="text-center py-2">
                <div className="loader"></div>
            </div>}
            <h4 className="text-primary mb-3">Commandes en attente</h4>

            <div className="mb-3 row g-3 align-items-center">
                <div className="col-sm-4">
                    <input
                        type="text"
                        placeholder="Rechercher client..."
                        className="form-control"
                        value={searchClient}
                        onChange={(e) => setSearchClient(e.target.value)}
                    />
                </div>
                <div className="col-sm-3">
                    <input
                        type="date"
                        className="form-control"
                        value={dateDebut}
                        onChange={(e) => setDateDebut(e.target.value)}
                    />
                </div>
                <div className="col-sm-3">
                    <input
                        type="date"
                        className="form-control"
                        value={dateFin}
                        onChange={(e) => setDateFin(e.target.value)}
                    />
                </div>
            </div>

            {commandesFiltrees.length === 0 && (
                <p className="text-muted">Aucune commande en attente pour ces filtres.</p>
            )}

            <div className="accordion" id="accordionCommandes">
                {commandesFiltrees.map((cmd) => (
                    <div key={cmd.id} className="accordion-item my-2">
                        <h2 className="accordion-header" id={`heading${cmd.id}`}>
                            <button
                                className="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target={`#collapse${cmd.id}`}
                                aria-expanded="false"
                                aria-controls={`collapse${cmd.id}`}
                            >
                                {cmd.no_cmd} • Client : {cmd.client.client} ({cmd.client.telephone}) - <span className="text-secondary">{new Date(cmd.created_at).toLocaleDateString()}</span>
                            </button>
                        </h2>
                        <div
                            id={`collapse${cmd.id}`}
                            className="accordion-collapse collapse"
                            aria-labelledby={`heading${cmd.id}`}
                            data-bs-parent="#accordionCommandes"
                        >
                            <div className="accordion-body">
                                <div className="mb-3">
                                    <button
                                        className={`btn btn-sm ms-auto btn-${editingCmdId === cmd.id ? 'danger' : 'primary'}`}
                                        onClick={() => toggleEdition(cmd)}
                                    >
                                        {editingCmdId === cmd.id ? "Annuler édition" : "Validation & Livraison"}
                                    </button>
                                </div>

                                {editingCmdId === cmd.id ? (
                                    <>
                                        <div className="table-responsive">
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Produit</th>
                                                        <th>Conteneur</th>
                                                        <th>Qté commandée</th>
                                                        <th>Prix unitaire (GNF)</th>
                                                        <th>Qté livrée</th>
                                                        <th>Montant</th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {cmd.details.map((detail) => {
                                                        const vals = editingDetails[detail.id] || {};
                                                        const pu = vals.pvu ?? detail.pvu;
                                                        const qteLivree = vals.quantite_livre ?? detail.quantite_livre ?? 0;
                                                        const montantLigne = pu * qteLivree;

                                                        return (
                                                            <tr key={detail.id}>
                                                                <td>{detail.produit.produit}</td>
                                                                <td>{detail.conteneur}</td>
                                                                <td>{detail.quantite_cmd}</td>
                                                                <td>{pu.toLocaleString()}</td>
                                                                <td>
                                                                    <input
                                                                        type="tel"
                                                                        inputMode="numeric"
                                                                        pattern="[0-9]*"
                                                                        className="form-control"
                                                                        value={qteLivree}
                                                                        onChange={(e) => {
                                                                            const val = e.target.value.replace(/^0+(?!$)/, '').replace(/\D/g, '');
                                                                            handleChange(detail.id, "quantite_livre", val);
                                                                        }}
                                                                        onBlur={(e) => {
                                                                            const val = e.target.value.replace(/\D/g, '');
                                                                            handleChange(detail.id, "quantite_livre", val);
                                                                        }}
                                                                    />
                                                                </td>
                                                                <td>{montantLigne.toLocaleString()}</td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>

                                        </div>
                                        <div className="d-flex flex-wrap justify-content-end align-items-center gap-3">
                                            <label className="mb-0">Remise (GNF) :</label>
                                            <input
                                                type="tel"
                                                inputMode="numeric"
                                                pattern="[0-9]*"
                                                className="form-control w-auto"
                                                value={remiseInput}
                                                onFocus={(e) => setRemiseInput(remise.toString())}
                                                onChange={(e) => {
                                                    const raw = e.target.value.replace(/\D/g, '').replace(/^0+(?!$)/, '');
                                                    setRemise(Number(raw));
                                                    setRemiseInput(raw);
                                                }}
                                                onBlur={() => setRemiseInput(remise.toLocaleString())}
                                            />

                                            <label className="mb-0">Montant payé (GNF) :</label>
                                            <input
                                                type="tel"
                                                inputMode="numeric"
                                                pattern="[0-9]*"
                                                className="form-control w-auto"
                                                value={payeInput}

                                                onChange={(e) => {
                                                    const raw = e.target.value.replace(/\D/g, '').replace(/^0+(?!$)/, '');
                                                    setPaye(Number(raw));
                                                    setPayeInput(raw);
                                                }}
                                                onBlur={() => setPayeInput(paye.toLocaleString())}
                                            />

                                            <strong>Total net : {calculerTotalNet().toLocaleString()} GNF</strong>
                                            <button
                                                className="btn btn-success ms-3"
                                                onClick={() => validerCommande(cmd.id)}
                                            >
                                                Valider & Livrer
                                            </button>
                                        </div>
                                    </>
                                ) : (
                                    <ul className="list-group list-group-flush">
                                        {cmd.details.map((detail, i) => (
                                            <li key={i} className="list-group-item d-flex justify-content-between">
                                                <span>{detail.produit.produit}</span>
                                                <span>
                                                    Qté : {detail.quantite_cmd} — PU : {detail.pvu.toLocaleString()} GNF — Qté livrée : {detail.quantite_livre || 0}
                                                </span>
                                            </li>
                                        ))}
                                    </ul>
                                )}

                                <div className="card-footer text-end fw-bold mt-3">
                                    Total : {cmd.montant_total.toLocaleString()} GNF
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CommandeAttente;
